jQuery( document ).ready(function() {
	gsap.registerPlugin(ScrollTrigger, SplitText, MotionPathPlugin, DrawSVGPlugin) //, TextPlugin, ScrollToPlugin, CSSRulePlugin

	ScrollTrigger.defaults({
		toggleActions: "play none none reverse",
		//markers: true,
		end: "bottom center",
	})

	// When the user scrolls the page, execute position_header
	window.onscroll = function() {position_header()}
	// Get the header
	const header = document.querySelector(".header-fixed")
	// Get the offset position of the navbar
	const sticky = header.offsetTop
	// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
	function position_header() {
		if (window.pageYOffset > sticky) {
			header.classList.remove("hide")
			header.classList.add("fixed")
		} else {
			header.classList.remove("fixed")
			header.classList.add("hide")
		}
	}

	let tlnav = gsap.timeline()

	tlnav.from('.navbar-mobile .nav-item', {
		delay: 0.0,
		duration: 0.05, 
		autoAlpha: 0,
		y: -100,
		stagger: 0.035
	})

	tlnav.pause()

	document.querySelector("#navbar-toggle").addEventListener('click', () => {
		tlnav.restart()
	})

	if (document.querySelector(".tableau-etapes")){
		let cases = Array.from(document.querySelectorAll(".case"))
		
		for (let i = 0 ; i < cases.length ; i++){
			cases[i].addEventListener('click', () => {
				if (cases[i].classList.contains("open")){
					cases[i].classList.remove("open")
					return
				} else {
					cases[i].classList.add("open")
				}
			})
		}
	}

	let logotl = gsap.timeline({repeat: -1, repeatDelay: 1.5})
		logotl.fromTo(".svg-rectangle", {
			opacity: 0,
		}, {
			opacity: 1,
			stagger: -0.5,
			duration: 0.5,
			lazy: false,
			delay: 0.2
		}
	)	
	logotl.play()

	if (document.querySelector(".landing")){

		gsap.to(".titre, .landing .prise-wrapper", {
			duration: 1, 
			autoAlpha: 1
		})
		

		const titre = new SplitText(".landing .titre", { type: "words,chars" }),
		charsTitre = titre.chars;

		gsap.fromTo(charsTitre, {
			scale: 0,
			ease: "power3.out",
		}, {
			autoAlpha: 1,
			scale: 1,
			stagger: 0.01,
			duration: 1,
			delay: 0.5
		})

		gsap.to(".accroche",
			{duration: 1, autoAlpha: 1}
		)

		const accroche = new SplitText(".landing .accroche p", { type: "words,chars" }),
		charsAccroche = accroche.chars;

		gsap.fromTo(charsAccroche, {
			scale: 0,
			ease: "power3.out",
		}, {
			scale: 1,
			stagger: 0.005,
			duration: 0.5,
			delay: 1.5
		})

		gsap.to(".landing .separator", {
			duration: 0.5,
			stagger: 0.2,
			autoAlpha: 1,
			delay: 0
		})

		gsap.to(".landing .wrap-button", {
			duration: 1,
			stagger: 0.5,
			autoAlpha: 1,
			delay: 3
		})

		// gsap.to(".landing .prise", {
		gsap.to(".landing .trace #path-white", {
			motionPath: {
				path: "#path-red",
				align: "#path-red",
				alignOrigin: [0.5, 0.95],
				autoRotate: 90,
				// autoRotate: 270,
			},
			duration: 2,
			delay: 1,
		})

		gsap.from(".landing .trace #path-paint",{
			duration: 2,
			drawSVG: 0,
			lazy: false,
			delay: 1,
		})
	}

	if (document.querySelector(".bg-cable-6")){

		gsap.from(".oblique-alt .cable",{
			scrollTrigger: {
				trigger: ".oblique-alt .cable"
			},
			height: 0,
			duration: 1,
			ease: "power3",
			lazy: false
		})

		gsap.from(".oblique-alt .cable",{
			scrollTrigger: {
				trigger: ".oblique-alt .cable"
			},
			width: 0,
			duration: 2,
			ease: CustomEase.create("custom", "M0,0 C0,0 0.05,0.228 0.09,0.373 0.12,0.484 0.139,0.547 0.18,0.654 0.211,0.737 0.235,0.785 0.275,0.864 0.291,0.896 0.304,0.914 0.325,0.944 0.39,1.04 0.506,1.064 0.56,1.064 0.606,1.064 0.694,1.047 0.728,1.038 0.816,1.013 0.858,1 0.95,1 0.984,1 1,1 1,1 "),
			delay: 1,
			lazy: false
		})

		gsap.from(".oblique-alt .prise", {
			scrollTrigger: {
				trigger: ".oblique-alt .prise"
			},
			x: 900,
			duration: 2,
			ease: CustomEase.create("custom", "M0,0 C0,0 0.05,0.228 0.09,0.373 0.12,0.484 0.139,0.547 0.18,0.654 0.211,0.737 0.235,0.785 0.275,0.864 0.291,0.896 0.304,0.914 0.325,0.944 0.39,1.04 0.506,1.064 0.56,1.064 0.606,1.064 0.694,1.047 0.728,1.038 0.816,1.013 0.858,1 0.95,1 0.984,1 1,1 1,1 "),
			delay: 1,
			lazy: false
		})		
	}

	if(document.querySelector("#section-2")){

		gsap.to("#section-2 .separator", {
			scrollTrigger: {
				trigger: "#section-2 .separator"
			},
			duration: 1,
			stagger: 0.3,
			autoAlpha: 1
		})
	}

	if (document.querySelector("#section-3")){

		gsap.to("#section-3 .separator",{
			duration: 1,
			stagger: 0.3,
			scrollTrigger: {
				trigger: "#section-3 .separator"
			},
			autoAlpha: 1
		})
	}

	if(document.querySelector(".bouton")){

		gsap.to(".bouton",{
			scrollTrigger: {
				trigger: ".bouton"
			},
			duration: 1,
			autoAlpha: 1,
			delay: 0.5
		})
	}

	if (document.querySelector(".split-50-50-alt")){

		gsap.from(".split-50-50-alt .line", {
			scrollTrigger: {
				trigger: ".split-50-50-alt .line"
			},
			height: 0,
			duration: 2,
			ease: "power3",
			lazy: false
		})

		gsap.from(".split-50-50-alt .left", {
			scrollTrigger: {
				trigger: ".split-50-50-alt .left"
			},
			x: 500,
			duration: 2,
			ease: "power3",
			lazy: false
		})

		gsap.from(".split-50-50-alt .right", {
			scrollTrigger: {
				trigger: ".split-50-50-alt .right"
			},
			x: -500,
			duration: 2,
			ease: "power3", 
			lazy: false
		})
	}

	if (document.querySelector(".split-50-50")){

		gsap.from(".split-50-50 .line", {
			scrollTrigger: {
				trigger: ".split-50-50 .line"
			},
			height: 0,
			duration: 2,
			ease: "power3",
			lazy: false
		})

		gsap.from(".split-50-50 .left", {
			scrollTrigger: {
				trigger: ".split-50-50 .left"
			},
			x: 650,
			duration: 2,
			ease: "power3",
			lazy: false
		})

		gsap.from(".split-50-50 .right", {
			scrollTrigger: {
				trigger: ".split-50-50 .right"
			},
			x: -650,
			duration: 2,
			ease: "power3",
			lazy: false
		})
	}

	if (document.querySelector(".split-70-30")){

		gsap.to(".split-70-30 .image-copropriete", {
			scrollTrigger: {
				trigger: ".split-70-30 .image-copropriete"
			},
			autoAlpha: 1,
			duration: 2,
			ease: "power3",
			delay: 1,
			stagger: 0.33
		})

		gsap.from(".split-70-30 .cercle", {
			scrollTrigger: {
				trigger: ".split-70-30 .cercle"
			},
			scale: 0,
			duration: 1,
			ease: CustomEase.create("custom", "M0,0 C0,0 0.05,0.228 0.09,0.373 0.12,0.484 0.139,0.547 0.18,0.654 0.211,0.737 0.235,0.785 0.275,0.864 0.291,0.896 0.304,0.914 0.325,0.944 0.39,1.04 0.506,1.064 0.56,1.064 0.606,1.064 0.694,1.047 0.728,1.038 0.816,1.013 0.858,1 0.95,1 0.984,1 1,1 1,1 "),
			lazy: false,
			delay: 1,
			stagger: 0.33
		})

		gsap.from("#cable-reverse",{
			duration: 2.5,
			drawSVG: 0,
			ease: "power3",
			lazy: false,
			scrollTrigger: {
				trigger: ".split-70-30 .assembly"
			},
		})

		gsap.from("#prise", {
			scrollTrigger: {
				trigger: ".split-70-30 .assembly"
			},
			motionPath: {
				path: "#cable",
				align: "#cable",
				alignOrigin: [0.5, 0],
				autoRotate: 90,
			},
			duration: 2.5,
			ease: "power3",
		})
	}

	if (document.querySelector(".rectangles")){

		gsap.from(".rectangles .cable", {
			scrollTrigger: {
				trigger: ".rectangles .cable"
			},
			x: 500,
			duration: 2,
			ease: "power3",
			lazy: false
		})

		gsap.from(".rectangles .prise", {
			scrollTrigger: {
				trigger: ".rectangles .prise"
			},
			x: 500,
			duration: 2,
			ease: "power3",
			lazy: false
		})
	}
});